const message_ES = {
    "data": [
        {
            "code": 500000,
            "message": "Error interno del sistema"
        },
        {
            "code": 500001,
            "message": "Patrocinador no encontrado"
        },
        {
            "code": 500002,
            "message": "Error de pago"
        },
        {
            "code": 500003,
            "message": "Error en el cambio de divisas"
        },
        {
            "code": 500004,
            "message": "Método de pago no encontrado"
        },
        {
            "code": 500005,
            "message": "Gateway de pago no encontrado"
        },
        {
            "code": 500006,
            "message": "Plan no encontrado"
        },
        {
            "code": 500007,
            "message": "El monto es nulo o cero"
        },
        {
            "code": 500008,
            "message": "El monto es nulo o saldo insuficiente en la billetera"
        },
        {
            "code": 500009,
            "message": "Cliente especial no puede ser patrocinador"
        },
        {
            "code": 500010,
            "message": "El id del plan debe ser Business Partner"
        },
        {
            "code": 500011,
            "message": "Patrocinador del usuario no encontrado"
        },
        {
            "code": 500012,
            "message": "Usuario no encontrado"
        },
        {
            "code": 500013,
            "message": "Fallo al intentar autenticar al usuario"
        },
        {
            "code": 500014,
            "message": "Error al decodificar token JWT"
        },
        {
            "code": 500015,
            "message": "Este token JWT no pertenece al usuario de la solicitud"
        },
        {
            "code": 500016,
            "message": "Nombre de usuario no está disponible"
        },
        {
            "code": 500017,
            "message": "Ya existe una cuenta asociada a este correo electrónico"
        },
        {
            "code": 500018,
            "message": "El campo Currency está vacío o nulo"
        },
        {
            "code": 500019,
            "message": "Error al subir el archivo"
        },
        {
            "code": 500020,
            "message": "El pago por transferencia no pudo ser confirmado"
        },
        {
            "code": 500021,
            "message": "Cliente especial no puede transferir ExtraCoin"
        },
        {
            "code": 500022,
            "message": "Saldo insuficiente en la billetera ExtraCoin"
        },
        {
            "code": 500023,
            "message": "Saldo insuficiente en la billetera"
        },
        {
            "code": 500024,
            "message": "Ya existe una cuenta asociada a este número de documento"
        },
        {
            "code": 500025,
            "message": "Este correo electrónico no corresponde a este usuario"
        },
        {
            "code": 500026,
            "message": "Plan del usuario no encontrado"
        },
        {
            "code": 500027,
            "message": "Voucher inválido"
        },
        {
            "code": 500028,
            "message": "El pago con voucher es válido solo para registro de Area Manager"
        },
        {
            "code": 500029,
            "message": "Id de transacción no encontrado"
        },
        {
            "code": 500030,
            "message": "Esta transacción no pertenece a este usuario"
        },
        {
            "code": 500031,
            "message": "Esta transacción no está pendiente de confirmación de transferencia"
        },
        {
            "code": 500032,
            "message": "Categoría no encontrada con el id correspondiente"
        },
        {
            "code": 500033,
            "message": "Atributo no encontrado con el id correspondiente"
        },
        {
            "code": 500034,
            "message": "El id del atributo no corresponde al usuario de la solicitud"
        },
        {
            "code": 500035,
            "message": "Cliente especial no puede crear productos"
        },
        {
            "code": 500036,
            "message": "Subcategoría no encontrada"
        },
        {
            "code": 500037,
            "message": "Producto no encontrado"
        },
        {
            "code": 500038,
            "message": "El id del producto no pertenece al usuario de la solicitud"
        },
        {
            "code": 500039,
            "message": "El producto ya está asociado a este atributo"
        },
        {
            "code": 500040,
            "message": "El monto mínimo para crear un cupón es 50"
        },
        {
            "code": 500042,
            "message": "Cupón inválido"
        },
        {
            "code": 500043,
            "message": "El cupón no pertenece al usuario patrocinador"
        },
        {
            "code": 500044,
            "message": "Cliente especial no puede crear cupones"
        },
        {
            "code": 500045,
            "message": "El producto no está asociado a este atributo"
        },
        {
            "code": 500046,
            "message": "El producto ya tiene variaciones registradas"
        },
        {
            "code": 500047,
            "message": "No puede crear una variación con los mismos atributos"
        },
        {
            "code": 500048,
            "message": "Todos los atributos deben tener al menos un valor asignado"
        },
        {
            "code": 500049,
            "message": "La marca no está asociada a la subcategoría"
        },
        {
            "code": 500050,
            "message": "Campo subcategory no encontrado"
        },
        {
            "code": 500051,
            "message": "Marca no encontrada"
        },
        {
            "code": 500052,
            "message": "El tipo no está asociado a la subcategoría"
        },
        {
            "code": 500053,
            "message": "Tipo no encontrado"
        },
        {
            "code": 500054,
            "message": "GenderProduct no está asociado a la subcategoría"
        },
        {
            "code": 500055,
            "message": "GenderProduct no encontrado"
        },
        {
            "code": 500056,
            "message": "Variación del producto no encontrada"
        },
        {
            "code": 500057,
            "message": "El producto puede tener solo 2 atributos"
        },
        {
            "code": 500058,
            "message": "El producto no tiene ningún atributo registrado"
        },
        {
            "code": 500059,
            "message": "Este producto tiene variaciones. No puede establecer el monto total"
        },
        {
            "code": 500060,
            "message": "Esta variación no corresponde a este producto"
        },
        {
            "code": 500061,
            "message": "El campo Language está vacío o nulo"
        },
        {
            "code": 500062,
            "message": "El pedido debe tener al menos un artículo"
        },
        {
            "code": 500063,
            "message": "Estado permitido: PUBLISHED o UNPUBLISHED"
        },
        {
            "code": 500064,
            "message": "Comprador y vendedor deben ser diferentes"
        },
        {
            "code": 500065,
            "message": "Pedido no encontrado"
        },
        {
            "code": 500066,
            "message": "Este pedido no pertenece a este usuario"
        },
        {
            "code": 500067,
            "message": "El producto en el artículo no pertenece al vendedor del pedido"
        },
        {
            "code": 500068,
            "message": "Artículo no encontrado en el pedido"
        },
        {
            "code": 500069,
            "message": "Este producto tiene variaciones, especifique un idvariation"
        },
        {
            "code": 500070,
            "message": "El porcentaje de extracoin debe estar entre 50% y 97% para Business Partners"
        },
        {
            "code": 500071,
            "message": "El porcentaje de extracoin debe estar entre 10% y 97% para Area Managers"
        },
        {
            "code": 500072,
            "message": "El porcentaje de extracoin está por encima de lo solicitado por el vendedor"
        },
        {
            "code": 500073,
            "message": "La suma de Extracoin + Wallet + Cash debe ser igual al total del pedido"
        },
        {
            "code": 500074,
            "message": "Sin stock -> Producto"
        },
        {
            "code": 500075,
            "message": "No se puede modificar/eliminar un artículo de un pedido que no está abierto"
        },
        {
            "code": 500076,
            "message": "Se ha excedido el monto máximo posible de extracoin. ¡Revise su pedido!"
        },
        {
            "code": 500077,
            "message": "Este usuario no es el vendedor de este pedido"
        },
        {
            "code": 500078,
            "message": "Este pedido no puede ser enviado"
        },
        {
            "code": 500079,
            "message": "Este usuario no es el comprador de este pedido"
        },
        {
            "code": 500080,
            "message": "Este pedido no puede ser recibido"
        },
        {
            "code": 500081,
            "message": "Carrera no encontrada"
        },
        {
            "code": 500082,
            "message": "La billetera de origen tiene saldo insuficiente para pagar la tarifa"
        },
        {
            "code": 500083,
            "message": "La billetera de destino tiene saldo insuficiente para pagar la tarifa"
        },
        {
            "code": 500084,
            "message": "La billetera Extracoin de origen tiene saldo insuficiente para transferir"
        },
        {
            "code": 500085,
            "message": "La billetera Extracoin de destino tiene saldo insuficiente para transferir"
        },
        {
            "code": 500086,
            "message": "ID de transferencia no encontrado"
        },
        {
            "code": 500087,
            "message": "Este usuario no tiene relación con esta transferencia"
        },
        {
            "code": 500088,
            "message": "El usuario de origen y destino son iguales"
        },
        {
            "code": 500089,
            "message": "El código de confirmación de transferencia no es correcto"
        },
        {
            "code": 500090,
            "message": "El usuario de origen aún no ha confirmado la transacción"
        },
        {
            "code": 500091,
            "message": "Solo puede calificar pedidos que marcó como recibidos"
        },
        {
            "code": 500092,
            "message": "Ya ha calificado este pedido"
        },
        {
            "code": 500093,
            "message": "Las calificaciones deben estar entre 1 y 5"
        },
        {
            "code": 500094,
            "message": "La contraseña actual es incorrecta"
        },
        {
            "code": 500095,
            "message": "La nueva contraseña debe ser diferente de la contraseña actual"
        },
        {
            "code": 500096,
            "message": "Token de confirmación de teléfono no encontrado"
        },
        {
            "code": 500097,
            "message": "Este número de teléfono ya está confirmado"
        },
        {
            "code": 500098,
            "message": "Código inválido - confirmación de número de teléfono"
        },
        {
            "code": 500099,
            "message": "Solo los Clientes especiales pueden actualizar a Area Manager"
        },
        {
            "code": 500100,
            "message": "Ya existe un pago asociado a este transactionid"
        },
        {
            "code": 500101,
            "message": "La transacción de pago no pudo ser confirmada"
        },
        {
            "code": 500102,
            "message": "Solo los Clientes especiales pueden actualizar a Business Partner"
        },
        {
            "code": 500103,
            "message": "Usuario inactivo. No puede solicitar retiros."
        },
        {
            "code": 500104,
            "message": "El usuario remitente no tiene relación con este pedido"
        },
        {
            "code": 500105,
            "message": "El usuario receptor no tiene relación con este pedido"
        },
        {
            "code": 500106,
            "message": "Mensaje de chat no encontrado"
        },
        {
            "code": 500107,
            "message": "El usuario no es el destinatario de este mensaje de chat"
        },
        {
            "code": 500108,
            "message": "Este usuario no puede ver los mensajes de este pedido"
        },
        {
            "code": 500109,
            "message": "Este perfil no puede indicar un Sale Promoter"
        },
        {
            "code": 500110,
            "message": "El id del plan debe ser Sale Promoter"
        },
        {
            "code": 500111,
            "message": "Sale Promoter no puede crear productos"
        },
        {
            "code": 500112,
            "message": "Admin no puede crear productos"
        },
        {
            "code": 500113,
            "message": "El usuario no tiene permiso de admin (superuser)"
        },
        {
            "code": 500114,
            "message": "Los campos latitude/longitude son obligatorios"
        },
        {
            "code": 500115,
            "message": "El campo origin of register es obligatorio"
        },
        {
            "code": 500116,
            "message": "Si el producto es descargable, debe proporcionar los campos downloadtype, urldownload y urldownloadsample"
        },
        {
            "code": 500117,
            "message": "Si al menos un artículo es un producto descargable, todos los artículos deben ser descargables"
        },
        {
            "code": 500118,
            "message": "Este pedido no tiene artículos descargables"
        },
        {
            "code": 500119,
            "message": "Este dispositivo ya está registrado"
        },
        {
            "code": 500120,
            "message": "Este dispositivo no está registrado"
        },
        {
            "code": 500121,
            "message": "Este dispositivo no pertenece a este usuario"
        },
        {
            "code": 500122,
            "message": "Producto descargable no puede crear variaciones"
        },
        {
            "code": 500123,
            "message": "Producto descargable no puede recibir atributos"
        },
        {
            "code": 500124,
            "message": "Retiro mínimo permitido violado"
        },
        {
            "code": 500125,
            "message": "Solo los Area Managers pueden crear productos con información técnica"
        },
        {
            "code": 500126,
            "message": "Id de información técnica no encontrado"
        },
        {
            "code": 500127,
            "message": "Campos weight, height, width o length no encontrados"
        },
        {
            "code": 500128,
            "message": "Este producto ya fue marcado como favorito por este usuario"
        },
        {
            "code": 500129,
            "message": "Este producto no fue marcado como favorito por este usuario"
        },
        {
            "code": 500130,
            "message": "Retiro no encontrado"
        },
        {
            "code": 500131,
            "message": "Este retiro ya fue procesado"
        },
        {
            "code": 500132,
            "message": "Este usuario ya está bloqueado"
        },
        {
            "code": 500133,
            "message": "Este usuario ya está desbloqueado"
        },
        {
            "code": 500134,
            "message": "Búsqueda no encontrada"
        },
        {
            "code": 500135,
            "message": "Esta búsqueda ya fue confirmada"
        },
        {
            "code": 500136,
            "message": "Ya existe una Marca con esta descripción"
        },
        {
            "code": 500137,
            "message": "Este tipo ya está asociado a esta subcategoría"
        },
        {
            "code": 500138,
            "message": "Esta marca ya está asociada a esta subcategoría"
        },
        {
            "code": 500139,
            "message": "Configuración del marketplace no encontrada"
        },
        {
            "code": 500140,
            "message": "Este producto no puede ser enviado. Contacte al vendedor."
        },
        {
            "code": 500141,
            "message": "Aún no podemos enviar desde este país."
        },
        {
            "code": 500142,
            "message": "No pudimos encontrar un transportista para su pedido."
        },
        {
            "code": 500143,
            "message": "Este vendedor aún no puede enviar"
        },
        {
            "code": 500144,
            "message": "Este producto no puede ser enviado en este momento"
        },
        {
            "code": 500146,
            "message": "Los productos descargables no pueden ser enviados"
        },
        {
            "code": 500147,
            "message": "Los servicios no pueden ser enviados"
        },
        {
            "code": 500148,
            "message": "Este pedido aún no tiene paquete asignado. ¡Espere unos minutos e intente de nuevo!"
        },
        {
            "code": 500149,
            "message": "Ya hay una recogida reservada para este paquete"
        },
        {
            "code": 500150,
            "message": "Solo el vendedor puede reservar una recogida"
        },
        {
            "code": 500151,
            "message": "Conversión no encontrada"
        },
        {
            "code": 500152,
            "message": "Conversión expirada"
        },
        {
            "code": 500153,
            "message": "Esta conversión no pertenece al usuario de la solicitud"
        },
        {
            "code": 500154,
            "message": "Esta conversión ya fue utilizada"
        },
        {
            "code": 500155,
            "message": "Este usuario ya registró la dirección. Para modificar, contacte al soporte."
        },
        {
            "code": 500156,
            "message": "Este pedido contiene un servicio. Todos los artículos deben ser servicios."
        },
        {
            "code": 500157,
            "message": "Este pedido no está asociado a un paquete."
        },
        {
            "code": 500158,
            "message": "¡Los Partners no pueden crear más de 50 productos publicados!"
        },
        {
            "code": 500159,
            "message": "¡Los Partners no pueden crear más de 50 productos no publicados!"
        },
        {
            "code": 500160,
            "message": "¡Tiene una suscripción de prueba! ¡No puede solicitar retiros!"
        },
        {
            "code": 500161,
            "message": "¡Solo Managers y Partners necesitan renovar la suscripción!"
        },
        {
            "code": 500162,
            "message": "¡Solo puede renovar su suscripción desde 10 días antes del vencimiento!"
        },
        {
            "code": 500163,
            "message": "¡La renovación no puede pagarse con este método de pago!"
        },
        {
            "code": 500164,
            "message": "¡Este método solo puede pagar renovación!"
        },
        {
            "code": 500165,
            "message": "¡Este voucher no puede usarse para pagar este plan!"
        },
        {
            "code": 500166,
            "message": "Código de seguridad inválido o expirado"
        },
        {
            "code": 500167,
            "message": "El id del plan debe ser Seller"
        },
        {
            "code": 500168,
            "message": "El porcentaje de extracoin debe estar entre 30% y 97% para Sellers"
        },
        {
            "code": 500169,
            "message": "Un producto no puede ser servicio y descargable al mismo tiempo"
        },
        {
            "code": 500170,
            "message": "Está intentando agregar un servicio a un pedido con artículos que no son servicios"
        },
        {
            "code": 500171,
            "message": "Pregunta del producto no encontrada"
        },
        {
            "code": 500172,
            "message": "Este usuario no puede responder esta pregunta"
        },
        {
            "code": 500173,
            "message": "Esta pregunta ya fue respondida"
        },
        {
            "code": 500174,
            "message": "No puede preguntar sobre su propio producto"
        },
        {
            "code": 500175,
            "message": "Notificación no encontrada"
        },
        {
            "code": 500176,
            "message": "Esta notificación no pertenece al usuario de la solicitud"
        },
        {
            "code": 500177,
            "message": "Sus notificaciones no pudieron enviarse porque su saldo de extracoin es insuficiente, pero su producto se registró correctamente"
        },
        {
            "code": 500178,
            "message": "Si su pedido tiene al menos un artículo con envío gratis, todos deben tener envío gratis"
        },
        {
            "code": 500179,
            "message": "No puede crear productos"
        },
        {
            "code": 500180,
            "message": "No puede actualizar a SilverPro"
        },
        {
            "code": 500181,
            "message": "No puede actualizar a GeoGold"
        },
        {
            "code": 500182,
            "message": "No puede actualizar a StartSeller"
        },
        {
            "code": 500183,
            "message": "Share Content no encontrado"
        },
        {
            "code": 500184,
            "message": "Este producto ya fue compartido por este usuario"
        },
        {
            "code": 500185,
            "message": "Billetera Extrabonus no encontrada"
        },
        {
            "code": 500186,
            "message": "Este pedido no puede recogerse en la dirección del vendedor"
        },
        {
            "code": 500187,
            "message": "publicKey no encontrada"
        },
        {
            "code": 500188,
            "message": "transactionidCrypto no encontrado"
        },
        {
            "code": 500189,
            "message": "Error de pago. No pudimos confirmar la transacción de su billetera crypto."
        },
        {
            "code": 500190,
            "message": "Si el producto es importado, debe proporcionar el campo OriginProductImported"
        },
        {
            "code": 500191,
            "message": "Si el producto es importado de Banggood, debe proporcionar el campo ProductIdBanggood"
        },
        {
            "code": 500192,
            "message": "Este producto no está asignado a este atributo"
        },
        {
            "code": 500193,
            "message": "¡Este atributo está asignado en al menos una variación! ¡Elimine las variaciones primero!"
        },
        {
            "code": 500194,
            "message": "Edite su producto y establezca el porcentaje de cashback antes de publicar"
        },
        {
            "code": 500195,
            "message": "El porcentaje de cashback debe estar entre 1% y 5% para Customers"
        },
        {
            "code": 500196,
            "message": "Tienda no encontrada"
        },
        {
            "code": 500197,
            "message": "Esta tienda no pertenece a este usuario"
        },
        {
            "code": 500198,
            "message": "Slug no disponible"
        },
        {
            "code": 500199,
            "message": "Este pedido ya está PAGADO"
        },
        {
            "code": 500200,
            "message": "Este pago no tiene transferencia bancaria asociada"
        },
        {
            "code": 500201,
            "message": "PaymentPlan no encontrado"
        },
        {
            "code": 500202,
            "message": "Este PaymentPlan ya está pagado"
        },
        {
            "code": 500203,
            "message": "Producto no disponible para la venta"
        },
        {
            "code": 500204,
            "message": "Solo el perfil de tienda puede usar este tipo de pago"
        },
        {
            "code": 500205,
            "message": "Pago no encontrado"
        },
        {
            "code": 500206,
            "message": "Fallo en la autenticación"
        },
        {
            "code": 500207,
            "message": "La suma de los valores de las dos billeteras (principal + extracredit) debe ser igual al monto a pagar"
        },
        {
            "code": 500208,
            "message": "Su perfil no permite esta operación"
        },
        {
            "code": 500209,
            "message": "Sección del marketplace no encontrada"
        },
        {
            "code": 500210,
            "message": "¡Tienda aún no configurada! Configúrela primero."
        },
        {
            "code": 500211,
            "message": "Este perfil no puede indicar este registro"
        },
        {
            "code": 500212,
            "message": "Fringe Benefit no encontrado"
        },
        {
            "code": 500213,
            "message": "Fringe Benefit Order no encontrado"
        },
        {
            "code": 500214,
            "message": "Fringe Benefit Order ya está pagado"
        },
        {
            "code": 500215,
            "message": "Este Fringe Benefit Order no pertenece a este usuario"
        },
        {
            "code": 500216,
            "message": "Cantidad insuficiente de este beneficio"
        },
        {
            "code": 500217,
            "message": "La suma de Extracoin + Wallet + Paypal debe ser el total del pedido"
        },
        {
            "code": 500218,
            "message": "No hay pago asignado a este pedido"
        },
        {
            "code": 500219,
            "message": "Voucher Fringe Benefit no encontrado"
        },
        {
            "code": 500220,
            "message": "Voucher Fringe Benefit ya fue utilizado"
        },
        {
            "code": 500221,
            "message": "Este voucher no puede usarse en este vendedor"
        },
        {
            "code": 500222,
            "message": "Instancia Whatsapp no encontrada"
        },
        {
            "code": 500223,
            "message": "Dirección no encontrada"
        },
        {
            "code": 500224,
            "message": "Esta dirección no pertenece a este usuario"
        },
        {
            "code": 500225,
            "message": "Este pedido no es para recogida en la dirección de la tienda"
        },
        {
            "code": 500226,
            "message": "Este pedido ya es para recogida en la dirección de la tienda"
        },
        {
            "code": 500227,
            "message": "Documento no encontrado"
        },
        {
            "code": 500228,
            "message": "No pudimos confirmar su correo electrónico"
        },
        {
            "code": 500230,
            "message": "No se encontraron solicitudes de cambio de contraseña"
        },
        {
            "code": 500231,
            "message": "Esta solicitud de cambio de contraseña ya fue utilizada"
        },
        {
            "code": 500232,
            "message": "La personalización del tema solo está permitida para Managers"
        },
        {
            "code": 500233,
            "message": "Tema no encontrado"
        },
        {
            "code": 500234,
            "message": "Este usuario no puede personalizar el tema"
        },
        {
            "code": 500235,
            "message": "Formato de número de teléfono inválido. Use el formato internacional con código de país (ej.: +393471234567)."
        },
        {
            "code": 500236,
            "message": "Cuenta bancaria no encontrada o no pertenece a este usuario"
        },
        {
            "code": 500237,
            "message": "Nombre del banco, IBAN y titular de la cuenta son obligatorios"
        },
        {
            "code": 500238,
            "message": "Número Whatsapp no encontrado, no pertenece a este usuario o ya confirmado"
        },
        {
            "code": 500239,
            "message": "¡Este usuario ya tiene un número WhatsApp asociado! Elimínelo para agregar otro."
        },
        {
            "code": 500240,
            "message": "Solo los managers pueden crear una subnet"
        },
        {
            "code": 500241,
            "message": "Este usuario ya tiene una subnet"
        },
        {
            "code": 500242,
            "message": "Código ATECO no encontrado"
        },
        {
            "code": 500243,
            "message": "Usuario no autorizado a eliminar este código ATECO"
        },
        {
            "code": 500244,
            "message": "El usuario no pertenece a ninguna subnet"
        },
        {
            "code": 500245,
            "message": "El usuario ya pertenece a una subnet"
        },
        {
            "code": 500246,
            "message": "Complete su registro con su dirección o autorice el uso de su geolocalización."
        },
        {
            "code": 500247,
            "message": "Este usuario ya tiene el formulario de perfil completado"
        },
        {
            "code": 500248,
            "message": "Los Customers no pueden crear más de 5 productos publicados"
        },
        {
            "code": 500249,
            "message": "Los Customers no pueden crear más de 5 productos no publicados"
        },
        {
            "code": 500250,
            "message": "Subnet no encontrada"
        },
        {
            "code": 500251,
            "message": "Este usuario no pertenece a esta subnet"
        },
        {
            "code": 500252,
            "message": "La tienda no está aprobada para ventas en tienda física. Envíe primero la prueba de tienda física."
        },
        {
            "code": 500253,
            "message": "No se encontró prueba de tienda física para este usuario"
        },
        {
            "code": 500254,
            "message": "El campo reason es obligatorio para el rechazo"
        },
        {
            "code": 500255,
            "message": "Esta tienda ya es StartSeller"
        },
        {
            "code": 500256,
            "message": "El campo physicalStoreName es obligatorio"
        },
        {
            "code": 500257,
            "message": "El campo proofPhotoUrl es obligatorio"
        },
        {
            "code": 500258,
            "message": "El campo physicalAddress es obligatorio"
        },
        {
            "code": 500259,
            "message": "El campo physicalCity es obligatorio"
        },
        {
            "code": 500260,
            "message": "La tienda debe aceptar los términos de la convención para continuar"
        },
        {
            "code": 500261,
            "message": "No se encontró convención firmada para esta tienda"
        },
        {
            "code": 500262,
            "message": "El campo legalRepresentativeName es obligatorio"
        },
        {
            "code": 500263,
            "message": "El campo taxId (Partita IVA / C.F.) es obligatorio"
        },
        {
            "code": 500264,
            "message": "El campo commercialName (Insegna) es obligatorio"
        },
        {
            "code": 500265,
            "message": "El campo address es obligatorio"
        },
        {
            "code": 500266,
            "message": "El campo city es obligatorio"
        },
        {
            "code": 500267,
            "message": "El campo merchantCategory es obligatorio"
        },
        {
            "code": 500268,
            "message": "La tienda debe firmar la convención Extraconomy antes de enviar la prueba de tienda física"
        },
        {
            "code": 500300,
            "message": "Fallo al autenticar con la API de Aruba (signin)"
        },
        {
            "code": 500301,
            "message": "Fallo al renovar el token de la API de Aruba (refresh)"
        },
        {
            "code": 500310,
            "message": "No fue posible determinar la provincia fiscal"
        },
        {
            "code": 500311,
            "message": "El documento del usuario está vacío"
        },
        {
            "code": 500312,
            "message": "El documento del usuario no corresponde a un Codice Fiscale ni a una Partita IVA"
        },
        {
            "code": 500313,
            "message": "Este tipo de usuario no tiene datos fiscales ni de dirección"
        },
        {
            "code": 500314,
            "message": "Datos de registro incompletos para emitir la factura"
        },
        {
            "code": 500315,
            "message": "La configuración del emisor (Extraconomy) está incompleta"
        },
        {
            "code": 500320,
            "message": "Este tipo de usuario no tiene datos fiscales"
        },
        {
            "code": 500321,
            "message": "Es necesario indicar si es Persona Física o Jurídica"
        },
        {
            "code": 500322,
            "message": "Tipo de persona inválido"
        },
        {
            "code": 500323,
            "message": "Este tipo de usuario no puede cambiarse al tipo seleccionado"
        },
        {
            "code": 500324,
            "message": "El nombre fiscal es obligatorio para Persona Jurídica"
        },
        {
            "code": 500325,
            "message": "Nombre y apellido son obligatorios para Persona Física"
        },
        {
            "code": 500326,
            "message": "El documento (CF/P.IVA) es obligatorio"
        },
        {
            "code": 500327,
            "message": "La dirección es obligatoria"
        },
        {
            "code": 500328,
            "message": "El número es obligatorio"
        },
        {
            "code": 500329,
            "message": "El código postal es obligatorio"
        },
        {
            "code": 500330,
            "message": "La ciudad es obligatoria"
        },
        {
            "code": 500331,
            "message": "El país es obligatorio"
        },
        {
            "code": 500400,
            "message": "Facturación automática bloqueada"
        },
        {
            "code": 500410,
            "message": "Monto de retiro inválido (nulo o ≤ 0)"
        },
        {
            "code": 500411,
            "message": "Cartera de tokens no encontrada para el usuario"
        },
        {
            "code": 500412,
            "message": "Saldo insuficiente para el retiro solicitado"
        },
        {
            "code": 500413,
            "message": "Solicitud de retiro no encontrada (al procesar)"
        },
        {
            "code": 500414,
            "message": "La solicitud ya había sido procesada anteriormente"
        },
        {
            "code": 500415,
            "message": "Informa la dirección EXC para el retiro"
        },
        {
            "code": 500416,
            "message": "Ingresa el código de verificación enviado por correo"
        }
    ]
}

export default message_ES;
